<template>
  <v-menu offset-y transition="scale-transition" origin="center left" right nudge-bottom=10>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" :title="$t('share.share')">
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-link</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('share.url') }}</v-list-item-title>
          <v-list-item-subtitle>{{ referer }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon v-clipboard:copy="referer" @click="$store.dispatch('message', { content: $t('share.urlCopied'), color: 'info' })">
            <v-icon color="grey lighten-1">mdi-content-copy</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-qrcode</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('share.qrCode') }}</v-list-item-title>
          <v-list-item-subtitle>{{ $t('share.shareQr') }}</v-list-item-subtitle>
          <qrcode v-show="false" :value="referer" :options="{ width: 400 }" tag="img" ref="qr"></qrcode>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="saveQR()">
            <v-icon color="grey lighten-1">mdi-download</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>  
  export default {
    components: {
    },
    props: {
      item : {
        required: true
      }
    },
    computed: {
      referer() {
        return window.location.origin + "/" + this.$mmconfig.slug + "/" + this.item.id
      }
    },
    data: () => ({
    }),
    created () {
    },
    watch: {
    },
    methods: {
      saveQR() {
        let img = this.$refs.qr.$el.src;
        var link = document.createElement("a");
        link.download = "qr-code_item-" + this.item.id + ".png";
        link.href = img;
        document.body.appendChild(link);
        this.$store.dispatch('message', { content: this.$t('share.downloadReady'), color: 'info' })
        link.click();
      }
    }
  }
</script>